module.exports = __webpack_public_path__ + "img/yuanxiaozyzshoucang1.709f2139.png";